import { observer } from "mobx-react";
import React from "react";
import { AgentControlCircle } from "../../components/call/agentControlCircle";
import { useStore } from "../../models";
import styles from "./agentCallSection.css";
import classNames from "classnames";
import { L10n } from "@fidget/common/i18n";

export interface Props {
  acceptCall: () => void;
  endCall: () => void;
  expandVideoButtonClicked: () => void;
  hideVideoButtonClicked: () => void;
  renderScreenToggleButton: () => JSX.Element;
  renderCobrowsingButton: () => JSX.Element;
  videoHidden: boolean;
  videoExpanded: boolean;
  isAnyVideoEnabled: boolean;
  isCobrowsingEnabled: boolean;
}

export const CallSectionButtons = observer(
  ({
    isAnyVideoEnabled,
    acceptCall,
    endCall,
    expandVideoButtonClicked,
    hideVideoButtonClicked,
    renderScreenToggleButton,
    renderCobrowsingButton,
    videoHidden,
    videoExpanded,
    isCobrowsingEnabled
  }: Props) => {
    const { callStore } = useStore();

    return (
      <div className={styles["buttons-container"]}>
        {(callStore.isConnecting && (
          <>
            {callStore.localMicrophone.isPermissionDenied && (
              <div className={styles["mic-perm-info"]}>
                <i className="icon-crossed-mic" />
                <L10n id={"header.call.changeMicPermissions"} />
              </div>
            )}
            <AgentControlCircle
              buttonStyle={{
                green: true,
                permissionDenied: callStore.localMicrophone.isPermissionDenied
              }}
              onClick={acceptCall}
            >
              <i className={"icon-call"} />
            </AgentControlCircle>
          </>
        )) || (
          <>
            {isAnyVideoEnabled && (
              <>
                <AgentControlCircle
                  buttonStyle={{ small: true }}
                  onClick={expandVideoButtonClicked}
                >
                  <div className={classNames(styles["small-inside"], styles.expand)}>
                    {(videoExpanded && <i className="icon-minimise-video-icon" />) || (
                      <i className="icon-expand-video-icon" />
                    )}
                  </div>
                </AgentControlCircle>
                <AgentControlCircle buttonStyle={{ small: true }} onClick={hideVideoButtonClicked}>
                  <div
                    className={classNames(styles["small-inside"], {
                      [styles.rotate]: !videoHidden
                    })}
                  >
                    <i className={"icon-arrow-up"} />
                  </div>
                </AgentControlCircle>
              </>
            )}
            {renderScreenToggleButton()}
            {isCobrowsingEnabled && renderCobrowsingButton()}
            <AgentControlCircle
              buttonStyle={{
                bright: callStore.localCamera.enabled,
                off: callStore.localScreen.enabled
              }}
              onClick={() => !callStore.localScreen.enabled && callStore.toggleCamera()}
            >
              <i className="icon-camera-crossed" />
            </AgentControlCircle>
            <AgentControlCircle
              buttonStyle={{ bright: callStore.localMicrophone.enabled }}
              onClick={() => callStore.toggleMicrophone()}
            >
              <i className="icon-crossed-mic" />
            </AgentControlCircle>
          </>
        )}
        <AgentControlCircle buttonStyle={{ red: true }} onClick={endCall} id={"end_call_button"}>
          <i className="icon-end-call" />
        </AgentControlCircle>
      </div>
    );
  }
);
